let Helper = {

    fields: {
        COMPANY_XML: 'UF_CRM_1628217729',
        COMPANY_ADDRESS: 'UF_CRM_1654137355',
        DEAL_DOGOVOR: 'UF_CRM_1629104762',
        DEAL_PAY: 'UF_CRM_1656039799852',
        DEAL_OTSROCHKA: 'UF_CRM_1654650729',
        DEAL_PAY_TAX_INCLUDE: 'UF_CRM_1661399367',
        DEAL_ADDRESS: 'UF_CRM_1686636872'
    },

    QuoteDays: [
        [365, 'пн'],
        [471, 'вт'],
        [473, 'ср'],
        [475, 'чт'],
        [477, 'пт'],
        [479, 'сб'],
        [559, 'вс'],
    ],

    contactStatusCode: [
        [337, 'new'],
        [339, 'active'],
        [341, 'temp_deleted'],
        [343, 'deleted'],
        [560, 'prev_deleted'],
        [751, 'restored'],
    ],

    contactStatusName: [
        [337, 'Новый'],
        [339, 'Активный'],
        [341, 'Приостановлен'],
        [343, 'Исключен'],
        [560, 'На отчисление'],
        [751, 'Восстановлен'],
    ],

    getStatusName(id) {
        let res = 'Не установлен';
        this.contactStatusName.map(item => {
            if (item[0] === parseInt(id)) {
                res = item[1]
            }
        });
        return res;
    },

    getStatusCode(id) {
        let res = '';
        this.contactStatusCode.map(item => {
            if (item[0] === parseInt(id)) {
                res = item[1]
            }
        });
        return res;
    },

    getStatusId(code) {
        let res = false;
        this.contactStatusCode.map(item => {
            if (item[1] === code) {
                res = item[0]
            }
        });
        return res;
    },

    getDayName(id) {
        let res = false
        this.QuoteDays.map(item => {
            if (parseInt(item[0]) === parseInt(id)) {
                res = item[1]
            }
        })

        return res;
    },

    getDayId(name) {
        let res = false
        this.QuoteDays.map(item => {
            if (item[1] === name) {
                res = item[0]
            }
        })

        return res;
    },

    /**
     * Клонирует массивы и объекты
     * @param variable
     * @returns {any}
     */
    clone: function (variable) {
        let arrayOrObj = null;

        if (Array.isArray(variable)) {
            arrayOrObj = []
        } else if (typeof variable === 'object' && variable !== null) {
            arrayOrObj = {}
        }

        if (!!arrayOrObj) {
            this.forEachObj(variable, (value, key) => {
                if (typeof value === 'object') {
                    arrayOrObj[key] = this.clone(value);
                } else {
                    arrayOrObj[key] = value;
                }
            })
        }

        return !!arrayOrObj ? arrayOrObj : variable
    },
    /**
     * Обходит объект аналогично методу forEach у массивов
     * @param object - объект для обхода
     * @param handler - функция-обработчик, в качестве аргументов получает значение, ключ и сам объект. Если функция вернёт false, обход завершится (будет выполнен break)
     * @param from - ключ, с которого нужно начать обход
     * @param end - ключ, на котором нужно завершить обход (данный ключ тоже не попадёт в обход)
     */
    forEachObj: function (object, handler, from = null, end = null) {
        var bActiveKey = (from === null);

        for (let key in object) {
            if ((end !== null) && (key === end)) break;

            if (key === from) {
                bActiveKey = true;
            }

            if (bActiveKey) {
                if (object.hasOwnProperty(key)) {
                    let result = handler(object[key], key, object);
                    if (result === false) {
                        break;
                    }
                }
            }
        }
    },

    buildTree: function (sections, parentId = null, section_key = 'section_id', id_key = 'id') {
        let tree = [];

        sections
            .filter((section) => section[section_key] === parentId)
            .forEach((section) => {

                const children = Helper.buildTree(sections, section[id_key], section_key, id_key)
                let children_section_id = []
                children.forEach(item => {
                    children_section_id.push(item[id_key])
                    if (item.children_section_id) {
                        children_section_id = children_section_id.concat(item.children_section_id)
                    }
                })

                tree.push({
                    ...section,
                    children: children.length > 0 ? children : null,
                    children_section_id: children_section_id.length > 0 ? children_section_id : null,
                });
                // tree[section[id_key]] = {
                //     ...section,
                //     children: Helper.buildTree(sections, section[id_key], section_key, id_key),
                // };
            });

        return tree;
    }
}

export default Helper